module.exports = __webpack_public_path__ + "img/logo-main.fcdf4880.png";